import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./popup.css";

const DisclaimerPopup = () => {
  const modalRef = useRef(null);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const hasSeenDisclaimer = localStorage.getItem("hasSeenDisclaimer");
    if (!hasSeenDisclaimer) {
      const modalElement = modalRef.current;
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();
    }
  }, []);

  const handleClose = () => {
    if (isChecked) {
      localStorage.setItem("hasSeenDisclaimer", "true");
    }
    const modalElement = modalRef.current;
    const modal = window.bootstrap.Modal.getInstance(modalElement);
    modal.hide();
  };
  return (
    <div
      className="disclaimer-modal modal fade"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      ref={modalRef}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title text-white">Disclaimer</h3>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
              disabled={!isChecked}
            ></button>
          </div>
          <div className="modal-body text-start">
            <p>
              This web application is provided as a tool for users to interact
              with the Rexla’s and our partners suite of products on their own
              initiative, with no endorsement or recommendation of
              cryptocurrency trading activities. In doing so, Rexla Global is
              not recommending that users or potential users engage in
              cryptoasset trading activity, and users or potential users of the
              web application should not regard this webpage or its contents as
              involving any form of recommendation, invitation or inducement to
              deal in cryptoassets. Our aim is to educate and allow transition
              when you are ready and confident to make your own decisions on how
              you wish to interact with cryptoassets.
            </p>
            <p>
              Please refer to our{" "}
              <Link to="/terms" target="_blank">
                Terms of Service
              </Link>{" "}
              for more details.
            </p>
            <div className="form-check mt-4">
              <input
                className="form-check-input"
                type="checkbox"
                id="doNotShowAgain"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <label className="form-check-label text-white" htmlFor="doNotShowAgain">
                I understand and accept this disclaimer.
              </label>
            </div>
          </div>

          <div className="modal-footer text-start">
            <div className="w-100 text-center">
              <button
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={!isChecked}
                onClick={handleClose}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPopup;
